module.exports = __webpack_public_path__ + "static/media/Primary_Tips_EN.4b39269f.pdf";